import type { ReactNode } from 'react'

import { TEST_ID } from '@/src/general/constants/testId'
import type { TWithBrowserTextareaHeightProps } from '@/src/general/utils/withBrowserTextareaHeight'
import { useTranslate } from '@/src/lang/useTranslate'

import { useCreateUpliftMutation } from '../../../services/useCreateUpliftMutation'
import { IntentionFormCtaBlock, type TIntentionFormCtaBlockProps } from '../IntentionFormCtaBlock'

type TUpliftFormProps = {
  userName: string
  intentionId: number
  prayerId: number
} & Partial<Pick<TIntentionFormCtaBlockProps, 'testID' | 'onDisplay' | 'onSubmit' | 'ref'>>

export const UpliftForm = ({
  testID,
  onSubmit,
  userName,
  intentionId,
  prayerId,
  ...otherProps
}: TUpliftFormProps & Partial<TWithBrowserTextareaHeightProps>): ReactNode => {
  const { t } = useTranslate()

  const { isSuccess, isPending, error, mutate } = useCreateUpliftMutation({ intentionId, prayerId })

  return (
    <IntentionFormCtaBlock
      contentFieldName="message"
      testID={testID ?? TEST_ID.INTENTION.UPLIFT.FORM.INPUT}
      title={isSuccess ? t('pray.uplift.sent', { userName }) : t('pray.uplift.title', { userName })}
      description={t('pray.uplift.description', { userName })}
      placeholder={t('words.your-message')}
      onSubmit={(message) => {
        mutate(message)
        onSubmit?.(message)
      }}
      button={{ testID: TEST_ID.INTENTION.UPLIFT.FORM.SUBMIT_BUTTON }}
      maxLength={400}
      error={error}
      isPending={isPending}
      isSuccess={isSuccess}
      {...otherProps}
    />
  )
}
